import {graphql, Environment, ConnectionHandler} from 'react-relay';
import {commitMutation, RecordSourceSelectorProxy, PayloadError} from 'relay-runtime';
import {
	CreateSavedPromptMutation_Mutation,
	CreateSavedPromptMutation_Mutation$data,
} from './__generated__/CreateSavedPromptMutation_Mutation.graphql';
import Util from '../../forecast-app/shared/util/util';

const mutation = graphql`
	mutation CreateSavedPromptMutation_Mutation($input: CreateSavedPromptInput!) {
		createSavedPrompt(input: $input) {
			savedPrompt {
				node {
					id
					name
					promptText
					createdAt
				}
			}
		}
	}
`;

function storeUpdater(store: RecordSourceSelectorProxy): void {
	const payload = store.getRootField('createSavedPrompt');
	if (!payload) return;
	const edge = payload.getLinkedRecord('savedPrompt');
	if (!edge) return;
	const newNode = edge.getLinkedRecord('node');
	if (!newNode) return;

	const viewer = store.getRoot().getLinkedRecord('viewer');
	if (!viewer) return;

	const connection = ConnectionHandler.getConnection(viewer, 'PromptDropdown_savedPrompts');
	if (!connection) return;

	const newEdge = ConnectionHandler.createEdge(store, connection, newNode, 'SavedPromptTypeEdge');
	ConnectionHandler.insertEdgeAfter(connection, newEdge);
}

type MutationInput = {name: string; promptText: string};

function commit(
	environment: Environment,
	input: MutationInput,
	onSuccess?: (
		response: CreateSavedPromptMutation_Mutation$data,
		errors: ReadonlyArray<PayloadError> | null | undefined
	) => void,
	onError?: (error: Error) => void
): void {
	const variables: CreateSavedPromptMutation_Mutation['variables'] = {
		input: {
			csrfToken: Util.getCsrfValue(),
			socketClientId: Util.getClientId(),
			...input,
		},
	};

	commitMutation<CreateSavedPromptMutation_Mutation>(environment, {
		mutation,
		variables,
		updater: storeUpdater,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
